import React, { useMemo, memo, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import { motion, useInView, useAnimation } from 'framer-motion'

import { CONCEPTS_ANIMATIONS } from 'constants/animations'
import { MACHINE_STATES } from 'constants/machines'
import AnimationMarkets from 'assets/animations/markets.json'
import AnimationBlackboard from 'assets/animations/blackboard.json'
import AnimationMachine from 'assets/animations/machine.json'
import LottiePlayer from 'components/Shared/LottiePlayer'
import Machine from 'components/Machines/Machine'

function ConceptAnimation({ animation }) {
  const ref = useRef(null)
  const [lottieRef, setLottieRef] = useState(null)
  const isInView = useInView(ref, { once: true, threshold: 1 })
  const controls = useAnimation()

  const animationData = useMemo(() => {
    if (isInView) {
      controls.start({
        opacity: [0, 1],
        transition: {
          duration: 1.5,
          ease: 'easeInOut',
          times: [0, 0.2, 0.5, 0.8, 1]
        }
      })
    }

    if (animation === CONCEPTS_ANIMATIONS.markets) return { animation: AnimationMarkets }

    if (animation === CONCEPTS_ANIMATIONS.blackboard) return { animation: AnimationBlackboard }

    return {
      animation: AnimationMachine,
      additional: (
        <Machine
          empty
          withQuarters={false}
          machineType="full_automatic_machine"
          status={MACHINE_STATES.producing}
        />
      )
    }
  }, [animation, isInView])

  function startLottie() {
    if (lottieRef) lottieRef.play()
  }

  return (
    <div className="concept-animation">
      <motion.div
        className="flex-row justify-center w-100"
        ref={ref}
        animate={controls}
        onAnimationComplete={startLottie}
      >
        <>
          {animationData.additional ? (
            <div className="concept-animation__machine">{animationData.additional}</div>
          ) : null}
          <LottiePlayer
            lottieRef={setLottieRef}
            animationData={animationData.animation}
            autoplay={false}
            loop={false}
            className={`concept-animation__banner concept-animation__banner--${animation}`}
          />
        </>
      </motion.div>
    </div>
  )
}

ConceptAnimation.propTypes = {
  animation: PropTypes.string.isRequired
}

export default memo(ConceptAnimation)
